/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable security/detect-non-literal-regexp */
/* eslint-disable no-unused-expressions */
/* eslint-disable security/detect-object-injection */
/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-unresolved */
import {
  // Link,
  Button,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import { memo, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router";
import { roleIDs } from "src/config/constant";
import { getPriorityRowClass, getPriorityTextClass } from "src/helpers/Dashboard";
import { findKeysByValue } from "src/helpers/FormDetails/ProposalDetails/resources";
import { SET_TOAST_ERROR, setStepDetails } from "src/redux/Actions/common";
import { setSortBy, setTableData } from "src/redux/Actions/dashboard";
import store from "src/redux/store";
import {
  actionBucketCall,
  downloadDocument,
  sendPaymentLinkCall,
  triggerWorkflow
} from "src/services/Dashboard";
import CustomBackDrop from "src/shared/CustomBackDrop";
import HighlightText from "src/shared/HighlightText";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import StorageService from "src/utils/Storage/storageService";
import Resources from "../../../config/Resources";
import {
  bucketBEMapping,
  bucketFormType,
  dashboardOptions,
  enterMEFJourney,
  PROPOSAL_STATUS,
  SOURCE
} from "../../../helpers/Dashboard/resources";
import { columnHeadings } from "../../../helpers/Dashboard/tableData";
import DashboardSelectField from "../../../shared/DashboardSelectField";
import CaseReassignModal from "./CaseReassignModal";
import GenericTableCell from "./GenericTableCell";

function ApplicationsTable() {
  const tableData = useAppSelector((state) => state.dashboard.tableData);
  const leadData = useAppSelector((state) => state.dashboard?.data?.data);
  const [applicationType, setApplicationType] = useState<{
    action?: string;
    formType?: string;
  }>({});
  const [reassignModal, setReassignModal] = useState({ status: false, leadId: "" });
  const [currIRM, setCurrIRM] = useState<Record<string, any>>();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const downloadURI = (url: any) => {
    const pdfUrl = url;
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = "document.pdf"; // specify the filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    store.dispatch(
      SET_TOAST_ERROR({
        error: true,
        type: "success",
        message: "File downloaded"
      })
    );
  };
  const { mutate: mutateActionBucket, isLoading: isActionBucketLoading } = useMutation(
    ["actionBucket"],
    (leadId: string) => actionBucketCall(leadId, bucketBEMapping[applicationType?.action!]),
    {
      retry: false
    }
  );
  const { mutate: mutateSendPaymentLink, isLoading: isSendPaymentLinkLoading } = useMutation(
    ["sendPaymentLink"],
    (leadId: string) => sendPaymentLinkCall(leadId),
    {
      retry: false
    }
  );
  const { mutate: downloadDoc, isLoading: isDownloadDocumentFetching } = useMutation(
    downloadDocument,
    {
      onSuccess: (res) => {
        downloadURI(res?.data);
      }
    }
  );

  const user = StorageService.getFromLocalStorage("user");
  const handleApplicationType = async (event: any, leadId: string) => {
    // const transformedValue =
    //   event.target.name === "action" ? event?.target?.value.split(" ")[0] : event.target.value;
    await setApplicationType({ ...applicationType, [event.target.name]: event.target.value });
    if (event.target.name === "action") {
      if (event.target.value === "Send Payment Link") {
        mutateSendPaymentLink(leadId, {
          onSuccess: () => {
            store.dispatch(
              SET_TOAST_ERROR({
                error: true,
                type: "success",
                message: "Payment Link Sent Successfully"
              })
            );
          }
        });
      } else {
        mutateActionBucket(leadId, {
          onSuccess: async () => {
            store.dispatch(
              setTableData({
                ...tableData,
                [leadId]: {
                  ...tableData[leadId],
                  action: bucketBEMapping[event.target.value],
                  ...(bucketBEMapping[event.target.value] === "Cancel" && {
                    proposalStatus: "Cancel"
                  })
                }
              })
            );
            store.dispatch(
              SET_TOAST_ERROR({
                error: true,
                type: "success",
                message: "Action Changed Successfully"
              })
            );
            // await queryClient.invalidateQueries({ queryKey: ["dashboard"] });
          }
        });
      }
    } else {
      store.dispatch(
        setTableData({
          ...tableData,
          [leadId]: { ...tableData[leadId], formType: event.target.value }
        })
      );
    }
  };
  const { mutate: mutateTriggerWorkflow, isLoading: isTriggerWorkflowLoading } = useMutation(
    triggerWorkflow,
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries({ queryKey: ["dashboard"] });
        store.dispatch(
          SET_TOAST_ERROR({
            error: true,
            type: "success",
            duration: 2000,
            message: "Workflow Completed!"
          })
        );
      },
      onError: () => {
        store.dispatch(
          SET_TOAST_ERROR({
            error: true,
            type: "error",
            message: "Workflow Failed!"
          })
        );
      }
    }
  );

  const handleColumnSorting = (label: string) => {
    store.dispatch(setSortBy(label));
  };
  const handleReassignButton = (leadId: string) => {
    setReassignModal({ status: true, leadId });
    setCurrIRM(leadData[leadId]?.QuoteIrmMapping || {});
  };

  // const checkPaymentLink = (leadId: any) => {
  //   if (
  //     tableData[leadId]?.proposalStatus === "MEF Submitted" &&
  //     tableData[leadId]?.funding === "self" &&
  //     tableData[leadId]?.paymentStatus !== "Success"
  //   ) {
  //     return true;
  //   }
  //   if (
  //     tableData[leadId]?.proposalStatus === "MEF Submitted" &&
  //     tableData[leadId]?.paymentStatus === "Short Premium"
  //   ) {
  //     return true;
  //   }
  //   return false;
  // };

  const handleTriggerWorkflow = (leadId: string) => {
    mutateTriggerWorkflow(leadId);
  };

  const handleFormDownloadClick = (leadId: string) => {
    if (tableData[leadId]?.formType === "BI")
      downloadDoc({ leadId, docName: tableData[leadId]?.formType });
    else if (
      tableData[leadId]?.formType === "MEF" &&
      tableData[leadId]?.proposalStatus === "MEF Submitted"
    ) {
      downloadDoc({ leadId, docName: tableData[leadId]?.formType });
    } else if (
      bucketFormType[tableData[leadId]?.formType] === "SPARK" &&
      tableData[leadId]?.proposalStatus === "MEF Submitted"
    ) {
      if (leadData[leadId]?.sparkFullDecision?.autoUnderwritingStatus?.description) {
        downloadDoc({ leadId, docName: bucketFormType[tableData[leadId]?.formType] });
      } else
        store.dispatch(
          SET_TOAST_ERROR({
            error: true,
            type: "info",
            duration: 4000,
            message: `Spark Decision is not available`
          })
        );
    } else
      store.dispatch(
        SET_TOAST_ERROR({
          error: true,
          type: "info",
          duration: 4000,
          message: `Cannot Download ${tableData[leadId]?.formType}. MEF Not Submitted`
        })
      );
  };

  const spreadTableData = (key: string, value: any, leadId: any) => {
    switch (key?.toLowerCase()) {
      case "applicationno":
        return (
          <p
            className="!text-unity !font-semibold !decoration-unity underline"
            onClick={() => {
              if (
                ![roleIDs.nbgo, roleIDs.bankEmployee, roleIDs.partnerAdmin]?.includes(user?.role) &&
                tableData[leadId]?.source === SOURCE.PHYSICAL &&
                tableData[leadId]?.proposalStatus === PROPOSAL_STATUS.IN_PROGRESS
              ) {
                store.dispatch(
                  SET_TOAST_ERROR({
                    error: true,
                    message: "Lead created by Data Entry Mechanism cannot be processed",
                    type: "warning",
                    duration: 4000
                  })
                );
                return;
              }
              store.dispatch(
                setStepDetails({
                  parentStepNo: 1,
                  proposerStepNo: 1,
                  reviewStepNo: 1
                })
              );
              enterMEFJourney(tableData[leadId])
                ? navigate(`/form-details/${leadId}`)
                : navigate(`/view-lead-details/${leadId}`);
            }}
            role="presentation"
          >
            <HighlightText text={value.length > 14 ? `${value.slice(0, 14)}...` : value} />
          </p>
        );
      case "download":
        return (
          <Button
            disableRipple
            disableTouchRipple
            classes={{
              root: "!hover:bg-transparent"
            }}
            className="!hover:bg-transparent"
            onClick={() => handleFormDownloadClick(leadId)}
          >
            <img src={Resources.images.Dashboard.downloadIcon} alt="download" />
          </Button>
        );
      case "casereassign":
        return (
          <Button
            disabled={
              !leadData[leadId]?.QuoteIrmMapping?.canEdit ||
              tableData[leadId]?.proposalStatus === "MEF Submitted"
            }
            onClick={() => handleReassignButton(leadId)}
            variant="contained"
            classes={{
              contained: "!rounded-lg !text-xs !leading-3.75 !-tracking-0.01 !font-montserrat"
            }}
            className="!text-center"
          >
            Assign
          </Button>
        );
      case "workflow":
        return (
          <Button
            disabled={
              !(
                tableData[leadId]?.proposalStatus === "MEF Submitted" &&
                !leadData[leadId]?.isWorkflowCompleted
              )
            }
            onClick={() => handleTriggerWorkflow(leadId)}
            variant="contained"
            classes={{
              contained: "!rounded-lg !text-xs !leading-3.75 !-tracking-0.01 !font-montserrat"
            }}
            className="!text-center"
          >
            Trigger
          </Button>
        );
      case "action":
        return (
          <DashboardSelectField
            disabled={
              tableData[leadId]?.proposalStatus === "In Progress" ||
              tableData[leadId]?.proposalStatus === "Cancel"
            }
            options={dashboardOptions(leadId, tableData, leadData)?.action}
            className="w-16"
            onChange={(event) => handleApplicationType(event, leadId)}
            name="action"
            isBordered={false}
            value={findKeysByValue(bucketBEMapping, value)}
          />
        );
      case "formtype":
        return (
          <DashboardSelectField
            options={
              // [...OPTIONS.formType, ...(user.role !== roleIDs.irm ? ["Spark O/P"] : [])]
              dashboardOptions(leadId, tableData, leadData)?.formType
            }
            className="w-16"
            onChange={(event) => handleApplicationType(event, leadId)}
            name="formType"
            isBordered={false}
            // defaultValue="BI"
            value={value}
          />
        );
      default:
        return 0;
    }
  };
  return (
    <>
      {reassignModal.status && (
        <CaseReassignModal
          onClose={() => {
            setReassignModal({ ...reassignModal, status: false });
            document.body.style.overflowY = "scroll";
          }}
          leadId={reassignModal.leadId}
          currIRM={currIRM!}
        />
      )}
      <CustomBackDrop
        open={
          isActionBucketLoading ||
          isSendPaymentLinkLoading ||
          isDownloadDocumentFetching ||
          isTriggerWorkflowLoading
        }
      />
      <TableContainer
        component={Paper}
        classes={{
          root: "!mx-auto !border !border-t-0 !border-palladium !border-y-white !rounded-none"
        }}
      >
        <Table className="min-w-max">
          <TableHead classes={{ root: "!sticky !-top-0" }}>
            <TableRow className="!bg-unity">
              {columnHeadings().map((heading) =>
                ["canEditMEF"].includes(heading.name) ? (
                  <></>
                ) : (
                  <GenericTableCell
                    key={heading.name}
                    onClick={() => heading.filterSort && handleColumnSorting(heading.name)}
                    label={heading.label}
                    containsIcon={heading.filterSort}
                    labelClassName="text-white !font-semibold font-montserrat whitespace-pre-line"
                    className="!py-2 !bg-unity"
                  />
                )
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(tableData)?.map((row: Record<string, any>, index: number) => (
              <TableRow
                key={index}
                className={`cursor-pointer ${
                  index % 2 !== 0 ? "bg-white" : ""
                } ${getPriorityRowClass(
                  row[1]?.priorityOrder
                )} transition-all ease-in-out duration-150`}
              >
                {columnHeadings().map((heading) =>
                  ["canEditMEF"].includes(heading.name) ? null : (
                    <GenericTableCell
                      key={heading.name}
                      label={row[1][heading.name] as string}
                      rowKey={heading.name?.toLowerCase()}
                      className="!py-3 !border-0"
                      labelClassName={`font-montserrat font-medium ${getPriorityTextClass(
                        row[1]?.priorityOrder
                      )}`}
                    >
                      {spreadTableData(heading.name, row[1][heading.name], row[0])}
                    </GenericTableCell>
                  )
                )}
                {/* {Object.entries(row[1])?.map((entry) =>
                  ["funding", "canEditMEF"].includes(entry[0]) ? (
                    <></>
                  ) : (
                    <GenericTableCell
                      label={entry[1] as string}
                      rowKey={entry[0]?.toLowerCase()}
                      className="!py-3 !border-0"
                      labelClassName="text-black font-montserrat font-medium"
                    >
                      {spreadTableData(entry[0], entry[1], row[0])}
                    </GenericTableCell>
                  )
                )} */}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

export default memo(ApplicationsTable);
